// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorMainContainer_container__1rikC"};